/**
 * ChatTOW - Combined JavaScript File
 * This file contains all ChatTOW functionality in a single file for easier maintenance
 * All CSS styles have been moved to src/css/custom.scss
 */
(function() {
    console.log('ChatTOW combined script loading');
    
    // Variables to track initialization and conversation
    var isInitialized = false;
    var isFullyReady = false;
    var retryCount = 0;
    var maxRetries = 3;
    var conversationHistory = []; // Store the full conversation
    
    function addTabHidingCSS() {
        // CSS is now handled by custom.scss - this function is kept for backward compatibility
        // but the actual CSS has been moved to the stylesheet
        console.log('ChatTOW: CSS is now handled by custom.scss');
    }
    
    /**
     * Main initialization function
     */
    function initChatTow() {
        console.log('ChatTOW: Initializing with page load time:', window.chatTowPageLoadTime || 'unknown');
        
        if (isInitialized) {
            console.log('ChatTOW: Already initialized, skipping');
            return;
        }
        
        isInitialized = true;
        retryCount = 0;
        
        // Add CSS (now a no-op since styles are in SCSS)
        addTabHidingCSS();
        
        // Verify requirements and show the tab
        setTimeout(verifyAndShowTab, 1000);
        
        console.log('ChatTOW: Initialization complete');
    }
    
    /**
     * Function to create elements and make tab ready
     */
    function verifyAndShowTab() {
        console.log('ChatTOW: Setting up ChatTOW components (attempt ' + (retryCount + 1) + ' of ' + maxRetries + ')');
        
        try {
            // Create or update the tab
            createTab();
            
            // Create the drawer (this creates the required elements)
            createDrawer();
            
            // Verify elements were created successfully
            var allElementsExist = function() {
                var requiredElements = [
                    'chat-tow-prompt',
                    'chat-tow-btn', 
                    'chat-tow-result'
                ];
                
                for (var i = 0; i < requiredElements.length; i++) {
                    if (!document.getElementById(requiredElements[i])) {
                        console.log('ChatTOW: Missing element after creation:', requiredElements[i]);
                        return false;
                    }
                }
                
                return true;
            };
            
            if (allElementsExist()) {
                console.log('ChatTOW: All elements created successfully');
                
                // Set up event handlers
                setupEventHandlers();
                
                // Apply styles
                applyStyles();
                
                // Mark as fully ready
                isFullyReady = true;
                
                // Add the ready class to show the tab
                document.body.classList.add('chat-tow-ready');
                
                // Force tab visibility as fallback (temporary debug measure)
                var tab = document.getElementById('chat-tow-tab-simple');
                if (tab) {
                    // Ensure tab is visible by applying inline styles as fallback
                    setTimeout(function() {
                        var computedDisplay = getComputedStyle(tab).display;
                        if (computedDisplay === 'none') {
                            console.warn('ChatTOW: Tab still hidden by CSS, applying inline override');
                            tab.style.display = 'block';
                            tab.style.visibility = 'visible';
                            tab.style.opacity = '1';
                            tab.style.position = 'fixed';
                            tab.style.top = '50%';
                            tab.style.right = '0';
                            tab.style.transform = 'translateY(-50%)';
                            tab.style.zIndex = '25000';
                            tab.style.backgroundColor = '#00a6cf';
                            tab.style.color = 'white';
                            tab.style.padding = '20px';
                            tab.style.cursor = 'pointer';
                        }
                    }, 100);
                }
                
                console.log('ChatTOW: Tab is now ready and visible');
                console.log('ChatTOW: Body classes:', document.body.className);
                
                // Debug: Check if tab element exists and has correct classes
                var tab = document.getElementById('chat-tow-tab-simple');
                if (tab) {
                    console.log('ChatTOW: Tab element found with classes:', tab.className);
                    console.log('ChatTOW: Tab computed styles:', {
                        display: getComputedStyle(tab).display,
                        visibility: getComputedStyle(tab).visibility,
                        opacity: getComputedStyle(tab).opacity,
                        position: getComputedStyle(tab).position,
                        zIndex: getComputedStyle(tab).zIndex
                    });
                } else {
                    console.error('ChatTOW: Tab element not found after creation!');
                }
            } else {
                throw new Error('Required elements were not created successfully');
            }
            
        } catch (error) {
            console.error('ChatTOW: Error during setup:', error);
            retryCount++;
            if (retryCount < maxRetries) {
                console.log('ChatTOW: Retrying setup in 2 seconds...');
                setTimeout(verifyAndShowTab, 2000);
            } else {
                console.warn('ChatTOW: Maximum retries reached, setup failed');
            }
        }
    }
    
    /**
     * Create or update the tab element
     */
    function createTab() {
        // Check if the tab already exists
        var existingTab = document.getElementById('chat-tow-tab-simple');
        if (existingTab) {
            console.log('ChatTOW tab already exists, ensuring it has the correct class');
            applyTabStyles(existingTab);
            return;
        }
        
        // Create a new tab if it doesn't exist
        var tab = document.createElement('div');
        tab.id = 'chat-tow-tab-simple';
        tab.innerHTML = '<span>Ask ChatTOW</span>';
        
        // Hide the tab initially until it's ready
        hideTabUntilReady(tab);
        
        // Apply styles (CSS is now in SCSS file)
        applyTabStyles(tab);
        
        // Add the tab to the body
        document.body.appendChild(tab);
        
        console.log('ChatTOW tab created and added to body');
    }
    
    /**
     * Hide tab until ready
     */
    function hideTabUntilReady(tab) {
        // CSS classes now handle visibility
        tab.className = 'chat-tow-tab chat-tow-loading';
    }
    
    /**
     * Apply styles to the tab element
     */
    function applyTabStyles(tab) {
        // All styles are now handled by CSS classes in custom.scss
        // Don't change the class if it's already in loading state
        if (!tab.classList.contains('chat-tow-loading')) {
            tab.className = 'chat-tow-tab';
        }
    }
    
    /**
     * Create the drawer element
     */
    function createDrawer() {
        // Check if the drawer already exists
        var existingDrawer = document.getElementById('chat-tow-drawer');
        if (existingDrawer) {
            console.log('ChatTOW drawer already exists, ensuring it has the correct class and styles');
            existingDrawer.className = 'chat-tow-drawer';
            applyDrawerStyles(existingDrawer);
            return;
        }
        
        // Create a new drawer if it doesn't exist
        var drawer = document.createElement('div');
        drawer.id = 'chat-tow-drawer';
        drawer.className = 'chat-tow-drawer';
        drawer.innerHTML = `
            <div class="chat-tow-drawer-content">
                <div class="chat-tow-header">
                    <h5>ChatTOW</h5>
                    <div class="header-actions">
                        <button id="chat-tow-close" class="chat-tow-close-btn">&times;</button>
                    </div>
                </div>
                <div class="chat-tow-body">
                    <div id="chat-tow-result" class="chat-tow-conversation">
                        <div class="welcome-message">
                            <div class="message-header">ChatTOW</div>
                            <div class="message-content">Welcome! Ask me any question about this content. I'll remember our conversation as we chat.</div>
                        </div>
                        <div class="chat-tow-input-area">
                            <div class="form-group">
                                <textarea id="chat-tow-prompt" class="form-control chat-tow-prompt" rows="2" placeholder="Type your question here..."></textarea>
                            </div>
                            <div class="input-actions">
                                <button id="chat-tow-btn" class="btn btn-primary chat-tow-btn">Ask ChatTOW</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        
        // Apply styles to the drawer
        applyDrawerStyles(drawer);
        
        // Add the drawer to the body
        document.body.appendChild(drawer);
        
        // Create and add the overlay separately
        var overlay = document.createElement('div');
        overlay.className = 'chat-tow-overlay';
        overlay.id = 'chat-tow-overlay';
        document.body.appendChild(overlay);
        
        console.log('ChatTOW drawer created and added to body');
    }
    
    /**
     * Apply critical inline styles to the drawer
     */
    function applyDrawerStyles(drawer) {
        // All styles are now handled by CSS classes in custom.scss
        // Just ensure the drawer has the correct class
        drawer.className = 'chat-tow-drawer';
        
        // Apply responsive styles based on screen size
        updateDrawerWidth();
    }
    
    /**
     * Set up event handlers
     */
    function setupEventHandlers() {
        // Tab click event
        var tab = document.getElementById('chat-tow-tab-simple');
        var drawer = document.getElementById('chat-tow-drawer');
        var overlay = document.getElementById('chat-tow-overlay');
        
        if (tab && drawer) {
            if (!tab._hasClickHandler) {
                tab.addEventListener('click', function() {
                    // Only allow interaction if fully ready
                    if (!isFullyReady) {
                        console.log('ChatTOW not fully ready yet, ignoring tab click');
                        return;
                    }
                    
                    console.log('Tab clicked, opening drawer');
                    
                    // Track drawer activity
                    window.lastDrawerActivity = Date.now();
                    
                    // Show drawer (overlay disabled to prevent black screen)
                    drawer.classList.add('open');
                    document.body.classList.add('chat-tow-drawer-open');
                    
                    // Debug: Check if drawer content exists
                    console.log('ChatTOW Debug - Drawer opened');
                    console.log('  Drawer classes:', drawer.className);
                    console.log('  Drawer transform:', getComputedStyle(drawer).transform);
                    console.log('  Overlay classes:', overlay ? overlay.className : 'No overlay');
                });
                tab._hasClickHandler = true;
            }
        }
        
        // Close button click event
        var closeBtn = document.getElementById('chat-tow-close');
        
        if (closeBtn && drawer) {
            if (!closeBtn._hasClickHandler) {
                closeBtn.addEventListener('click', function() {
                    console.log('Close button clicked, closing drawer');
                    
                    // Track drawer activity
                    window.lastDrawerActivity = Date.now();
                    
                    // Hide drawer
                    drawer.classList.remove('open');
                    document.body.classList.remove('chat-tow-drawer-open');
                    
                    // Immediately restore tab visibility after drawer closes
                    var tab = document.getElementById('chat-tow-tab-simple');
                    if (tab && isFullyReady) {
                        // Small delay to let drawer close animation start, then show tab
                        setTimeout(function() {
                            tab.style.cssText = '';
                            document.body.classList.add('chat-tow-ready');
                            console.log('ChatTOW: Tab restored immediately after drawer close');
                        }, 50);
                    }
                });
                closeBtn._hasClickHandler = true;
            }
        }
        
        // Submit button click event
        var btn = document.getElementById('chat-tow-btn');
        var prompt = document.getElementById('chat-tow-prompt');
        var result = document.getElementById('chat-tow-result');
        
        if (btn && prompt && result) {
            // Add keyboard support for Enter to submit
            if (!prompt._hasKeyHandler) {
                prompt.addEventListener('keydown', function(e) {
                    if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault(); // Prevent new line
                        btn.click(); // Trigger submit
                    }
                    // Shift+Enter allows new line (default behavior)
                });
                prompt._hasKeyHandler = true;
            }
            
            // Button click handler
            if (!btn._hasClickHandler) {
                btn.addEventListener('click', function() {
                    var question = prompt.value.trim();
                    
                    if (question === '') {
                        alert('Please enter a question.');
                        return;
                    }
                    
                    // Clear the prompt
                    prompt.value = '';
                    
                    // Create user message
                    var userMessage = document.createElement('div');
                    userMessage.className = 'chat-message user-message';
                    userMessage.innerHTML = '<div class="message-header">You</div><div class="message-content">' + question + '</div>';
                    result.appendChild(userMessage);
                    
                    // Create bot message placeholder for loading
                    var botMessage = document.createElement('div');
                    botMessage.className = 'chat-message bot-message';
                    botMessage.innerHTML = '<div class="message-header">ChatTOW</div><div class="message-content"><span class="typing-indicator">Thinking...</span></div>';
                    result.appendChild(botMessage);
                    
                    // Keep reference to the current bot message
                    var currentBotMessage = botMessage;
                    
                    // Scroll to bottom to show the new messages
                    result.scrollTop = result.scrollHeight;
                    
                    // Prepare conversation history
                    conversationHistory.push({
                        role: 'user',
                        content: question
                    });
                    
                    // Get CSRF token for Craft CMS
                    var csrfToken = '';
                    
                    // Method 1: Try from input field
                    var csrfInput = document.querySelector('input[name="CRAFT_CSRF_TOKEN"]');
                    if (csrfInput) {
                        csrfToken = csrfInput.value;
                    }
                    
                    // Method 2: Try from meta tag
                    if (!csrfToken) {
                        var csrfMeta = document.querySelector('meta[name="csrf-token"]');
                        if (csrfMeta) {
                            csrfToken = csrfMeta.getAttribute('content');
                        }
                    }
                    
                    // Method 3: Try from cookie
                    if (!csrfToken) {
                        var cookies = document.cookie.split(';');
                        for (var i = 0; i < cookies.length; i++) {
                            var cookie = cookies[i].trim();
                            if (cookie.startsWith('CRAFT_CSRF_TOKEN=')) {
                                csrfToken = decodeURIComponent(cookie.substring('CRAFT_CSRF_TOKEN='.length).split('|')[0]);
                                break;
                            }
                        }
                    }
                    
                    console.log('ChatTOW: CSRF token found:', csrfToken ? 'Yes' : 'No');
                    
                    // Prepare headers
                    var headers = {
                        'Content-Type': 'application/json',
                    };
                    
                    // Add CSRF token if available
                    if (csrfToken) {
                        headers['X-CSRF-Token'] = csrfToken;
                    }
                    
                    // Prepare FormData like the working bedrock simple interface
                    var formData = new FormData();
                    formData.append('query', question);
                    formData.append('model', 'anthropic.claude-3-5-sonnet-20240620-v1:0');
                    formData.append('temperature', '0.7');
                    formData.append('maxTokens', '1000');
                    
                    // Add CSRF token to FormData if available
                    if (csrfToken) {
                        formData.append('CRAFT_CSRF_TOKEN', csrfToken);
                    }
                    
                    // Get the correct URL like the working interface does
                    var generateUrl = '/aws/bedrock/generate'; // Default fallback
                    
                    // Try to get URL from meta tag (like the working interface)
                    var actionUrlMeta = document.querySelector('meta[name="aws-bedrock-generate-url"]');
                    if (actionUrlMeta) {
                        generateUrl = actionUrlMeta.getAttribute('content');
                        console.log('ChatTOW: Using meta tag URL:', generateUrl);
                    } else {
                        // Try to detect from current page structure
                        var currentPath = window.location.pathname;
                        if (currentPath.includes('/towedit/')) {
                            generateUrl = '/towedit/aws/bedrock/generate';
                        }
                        console.log('ChatTOW: Using detected URL:', generateUrl);
                    }
                    
                    // Make the API request to the working bedrock endpoint
                    console.log('ChatTOW: Making API request to ' + generateUrl + ' with question:', question);
                    fetch(generateUrl, {
                        method: 'POST',
                        headers: {
                            'X-CSRF-Token': csrfToken,
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json'
                        },
                        body: formData
                    })
                    .then(function(response) {
                        console.log('ChatTOW: API Response status:', response.status, response.statusText);
                        console.log('ChatTOW: Request URL was:', generateUrl);
                        console.log('ChatTOW: Current page path:', window.location.pathname);
                        if (!response.ok) {
                            if (response.status === 404) {
                                throw new Error('API endpoint not found (404). Tried URL: ' + generateUrl + ' from page: ' + window.location.pathname);
                            } else if (response.status === 500) {
                                throw new Error('Server error (500). Please check server logs.');
                            } else {
                                throw new Error('Network error (' + response.status + '): ' + response.statusText);
                            }
                        }
                        return response.json();
                    })
                    .then(function(data) {
                        console.log('API Response:', data);
                        
                        // Check if we have a valid response (bedrock format)
                        if (data && data.success && data.content) {
                            var answer = data.content;
                            var sources = data.sources || [];
                            
                            // Create formatted answer content with inline sources
                            var answerContent = '<div class="answer-body">' + answer + '</div>';
                            
                            // Add inline sources if they exist
                            if (sources && sources.length > 0) {
                                console.log('Processing sources:', sources);
                                answerContent += '<div class="inline-sources" style="margin-top: 15px; padding: 10px; background: #f8f9fa; border-radius: 5px;">';
                                answerContent += '<div class="sources-header" style="font-weight: bold; margin-bottom: 10px;">Sources:</div>';
                                
                                sources.forEach(function(source, index) {
                                    answerContent += '<div class="inline-source-item" style="margin-bottom: 8px; padding: 8px; background: white; border-radius: 3px; border-left: 3px solid #00a6cf;">';
                                    answerContent += '<div class="source-title" style="font-weight: bold; margin-bottom: 3px;">' + (source.title || 'Source ' + (index + 1)) + '</div>';
                                    answerContent += '<div class="source-content">' + (source.content || source.text || 'No content available') + '</div>';
                                    answerContent += '</div>';
                                });
                                
                                answerContent += '</div>';
                            }
                            
                            // Update bot message content
                            var botMessageContent = currentBotMessage.querySelector('.message-content');
                            if (botMessageContent) {
                                botMessageContent.innerHTML = answerContent;
                            }
                            
                            // Add response to conversation history
                            conversationHistory.push({
                                role: 'assistant', 
                                content: answer
                            });
                            
                            // Move input area to always be the last element in conversation
                            moveInputAreaToInline();
                            
                            // Scroll to bottom
                            result.scrollTop = result.scrollHeight;
                            console.log('ChatTOW: Added response with inline sources to conversation');
                        } else {
                            // Handle bedrock error format
                            var errorMessage = 'Unknown error';
                            if (data && data.error) {
                                errorMessage = data.error;
                            } else if (data && !data.success) {
                                errorMessage = 'Request was not successful';
                            } else {
                                errorMessage = 'No content in response';
                            }
                            
                            var botMessageContent = currentBotMessage.querySelector('.message-content');
                            if (botMessageContent) {
                                botMessageContent.innerHTML = '<div class="error-message">Error: ' + errorMessage + '</div>';
                            }
                            console.error('ChatTOW: Error from bedrock endpoint:', data);
                        }
                    })
                    .catch(function(error) {
                        // Hide sources section on error
                        var sourcesSection = document.querySelector('.chat-tow-sources');
                        if (sourcesSection) sourcesSection.style.display = 'none';
                        
                        // Update the bot message with error
                        var botMessageContent = currentBotMessage.querySelector('.message-content');
                        if (botMessageContent) {
                            botMessageContent.innerHTML = '<div class="error-message">Error: ' + error.message + '</div>';
                        } else {
                            // Fallback - create new error message
                            var errorMessage = document.createElement('div');
                            errorMessage.className = 'chat-message bot-message error';
                            errorMessage.innerHTML = '<div class="message-header">ChatTOW</div><div class="message-content"><div class="error-message">Error: ' + error.message + '</div></div>';
                            result.appendChild(errorMessage);
                        }
                        
                        // Move input area to always be the last element in conversation  
                        moveInputAreaToInline();
                        
                        // Scroll to bottom
                        result.scrollTop = result.scrollHeight;
                        
                        console.error('Chat error:', error);
                    });
                });
                btn._hasClickHandler = true;
            }
        } else {
            console.warn('Could not find all ChatTOW drawer elements for setting up event handlers');
        }
    }
    
    /**
     * Apply styles and handle responsive behavior
     */
    function applyStyles() {
        // Set up a MutationObserver to handle any dynamically added drawer
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                // Check if nodes were added to the body
                if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                    // Find the drawer content and apply width
                    updateDrawerWidth();
                }
            });
        });
        
        // Start observing the body
        observer.observe(document.body, { childList: true, subtree: true });
        
        // Run immediately
        updateDrawerWidth();
        
        // Set up resize listener
        window.addEventListener('resize', updateDrawerWidth);
    }
    
    /**
     * Update the drawer width based on screen size
     */
    function updateDrawerWidth() {
        // Width is now handled by CSS media queries in custom.scss
        // This function is kept for compatibility but doesn't need to do anything
        var drawerContent = document.querySelector('.chat-tow-drawer-content');
        if (drawerContent) {
            console.log('ChatTOW drawer width managed by CSS media queries');
        } else {
            console.warn('ChatTOW drawer content not found for width update');
        }
    }
    
    /**
     * Move input area to always be the last element in the conversation
     */
    function moveInputAreaToInline() {
        var inputArea = document.getElementById('chat-tow-prompt').closest('.chat-tow-input-area');
        var result = document.getElementById('chat-tow-result');
        
        if (inputArea && result) {
            console.log('ChatTOW: Moving input area to be the last element in conversation');
            
            // Add inline class for CSS styling (if not already added)
            if (!inputArea.classList.contains('inline')) {
                inputArea.classList.add('inline');
            }
            
            // Always move to the end - remove from current position and append to conversation area
            // This ensures it's always the last element after each response
            result.appendChild(inputArea);
            
            // Scroll to bottom to show the new input area
            result.scrollTop = result.scrollHeight;
            
            console.log('ChatTOW: Input area moved to end of conversation successfully');
        }
    }
    
    /**
     * Ensure tab visibility when drawer is closed (only if fully ready)
     */
    function ensureTabVisibility() {
        var tab = document.getElementById('chat-tow-tab-simple');
        var drawer = document.getElementById('chat-tow-drawer');
        
        if (tab && drawer && isFullyReady) {
            // Only restore tab if drawer is definitively closed AND not recently used
            var drawerClosed = !drawer.classList.contains('open') && !document.body.classList.contains('chat-tow-drawer-open');
            
            if (drawerClosed) {
                // Check if drawer was recently closed (avoid interference)
                var timeSinceLastUse = Date.now() - (window.lastDrawerActivity || 0);
                if (timeSinceLastUse > 5000) { // Only restore if drawer inactive for 5+ seconds
                    // Clear any inline styles and let CSS handle visibility
                    tab.style.cssText = '';
                    // Make sure body has ready class
                    if (!document.body.classList.contains('chat-tow-ready')) {
                        document.body.classList.add('chat-tow-ready');
                        console.log('ChatTOW: Tab visibility ensured via periodic check');
                    }
                }
            }
        } else if (tab && !isFullyReady) {
            // Keep tab hidden if not fully ready
            hideTabUntilReady(tab);
        }
    }

    /**
     * Set up periodic visibility checks
     */
    function setupVisibilityChecks() {
        // Check tab visibility every 10 seconds (reduced frequency to prevent interference)
        setInterval(ensureTabVisibility, 10000);
        
        // Also check on page visibility change
        document.addEventListener('visibilitychange', function() {
            if (!document.hidden) {
                setTimeout(ensureTabVisibility, 100);
            }
        });
        
        // Also check if functionality becomes ready periodically (less frequent)
        setInterval(function() {
            if (!isFullyReady && isInitialized) {
                verifyAndShowTab();
            }
        }, 5000);
    }
    
    // Initialize when the page is fully loaded (not just DOM ready)
    if (document.readyState === 'complete') {
        // Page is already fully loaded
        window.chatTowPageLoadTime = Date.now();
        initChatTow();
    } else {
        // Wait for the full page load (including images, stylesheets, etc.)
        window.addEventListener('load', function() {
            window.chatTowPageLoadTime = Date.now();
            initChatTow();
        });
        
        // Fallback: also listen for DOMContentLoaded in case load event doesn't fire
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                if (!window.chatTowPageLoadTime) {
                    setTimeout(function() {
                        window.chatTowPageLoadTime = Date.now();
                        initChatTow();
                    }, 1000);
                }
            });
        }
    }
    
    // Set up periodic visibility checks
    setupVisibilityChecks();
})(); 